angular.module 'zc.commonApi'

.service "SegmentEstimator", (
  MasterMongoSession,
  MasterMongoVisitor,
  MasterAccessStats,
  SegmentMatcher,
  $q
) ->
  class SegmentEstimator
    buildQueryWithTiming = (combinedQuery, timingSegments) ->
      originalSessionOr = combinedQuery['$or'] || []
      originalVisitorOr = combinedQuery['visitor']['$or'] || []
      delete combinedQuery['$or'] unless _.isEmpty(originalSessionOr)
      delete combinedQuery['visitor']['$or'] unless _.isEmpty(originalVisitorOr)
      timingSessionsQueries = _.chain(timingSegments)
        .map(SegmentMatcher.createSegmentQuery)
        .compact()
        .filter( (x) -> ! _.isEmpty(x))
        .value()
      timingVisitorsQueries = _.chain(timingSegments)
        .map(SegmentMatcher.createVisitorQuery)
        .compact()
        .filter( (x) -> ! _.isEmpty(x))
        .value()

      combinedQuery['$and'] ||= [] unless _.isEmpty(originalSessionOr) && _.isEmpty(timingSessionsQueries)
      for query in [originalSessionOr, timingSessionsQueries]
        combinedQuery['$and'] = combinedQuery['$and'].concat [
          {'$or': query}
        ] unless _.isEmpty(query)

      combinedQuery['visitor']['$and'] ||= [] unless _.isEmpty(originalVisitorOr) || _.isEmpty(timingVisitorsQueries)
      for query in [originalVisitorOr, timingVisitorsQueries]
        combinedQuery['visitor']['$and'] = combinedQuery['visitor']['$and'].concat [
          {'$or': query},
        ] unless _.isEmpty(query)

      combinedQuery

    @filterSessionsBySegmentQuery: (mongo_query, device, sessions, timingSegments) ->
      segmentQuery = SegmentMatcher.createSegmentQuery(mongo_query)
      visitorQuery = SegmentMatcher.createVisitorQuery(mongo_query)

      combinedQuery = segmentQuery
      combinedQuery.visitor = visitorQuery

      if timingSegments
        combinedQuery = buildQueryWithTiming combinedQuery, timingSegments

      deviceSessions = sessions
      if device != 'all'
        combinedQuery.device = device
        deviceQuery = { device }
        deviceSessions = SegmentMatcher.matchSessions(deviceQuery, sessions)

      matchedSessions = SegmentMatcher.matchSessions(combinedQuery, sessions)
      return {
        matchedSessions
        deviceSessions
      }

    @getSessions: (apikey, timeLimitDate) ->
      # timeLimit should be like: (Date)
      SESSIONS_TO_GET = 1000
      CHUNK_SIZE = 100

      sessions = []
      query = {apikey}
      if timeLimitDate
        _.merge query,
          opened_at:
            $lt:
              timeLimitDate

      MasterMongoSession.find(query, { limit: SESSIONS_TO_GET, sort: "-opened_at" })
      .then (_sessions) ->
        sessions = _sessions
        uuids = _.chain(sessions).map('_uuid').uniq().value()
        # Passing all uuids at once creates a facade v2 request with too long URL,
        # resulting in error on some environments (staging and production).
        # So, split uuids by chunk
        chunks = _.chunk(uuids, CHUNK_SIZE)
        promises = _.map chunks, (chunk) ->
          MasterMongoVisitor.find({_id: { $in: chunk }})
        $q.all promises
      .then (visitors) ->
        visitors = _.flatten(visitors)
        _.each sessions, (session) ->
          _.each visitors, (visitor) ->
            if visitor._id == session._uuid
              session.visitor = visitor
        return sessions

    @getAccessStats: (apikey, start_at, segment_id) ->
      MasterAccessStats.find({
        apikey: apikey,
        start_at: start_at,
        is_control: null
        is_after_installed_at: null
         # instead of specifying device, take all
        # device: null
        total_conversion_count: null
        campaign_segment_id: { $in: [ null, segment_id ] }
      }).then (res) ->
        accessStatsTotalCounts = {all: 0}
        accessStatsMatchedCounts = {all: 0}
        accessStatsStart = null
        accessStatsEnd = null
        _.chain(res)
         .groupBy (d) -> d.campaign_segment_id
         .each (grouped) ->
           _.each grouped, (stat) ->
             if stat.campaign_segment_id is null
               accessStatsTotalCounts[stat.device || "all"] = stat.session_count
             else if stat.campaign_segment_id == segment_id
               accessStatsMatchedCounts[stat.device || "all"] = stat.session_count
             accessStatsStart = stat.start_at
             accessStatsEnd = stat.end_at
          .value()
        return {
          accessStatsTotalCounts
          accessStatsMatchedCounts
          accessStatsStart
          accessStatsEnd
        }



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/misc/segment_estimator.service.coffee